import { api } from "@";

// TODO: replace endpoints with real backend routes once available.
// Each "save" call should accept { provider, settings } and persist server-side.

/* ---------- Payment gateways ---------- */
export const getPaymentSettings = () => api.get(`/api/AdminIntegrations/payments`);
export const savePaymentSettings = (data) =>
  api.post(`/api/AdminIntegrations/payments`, data);

/* ---------- WhatsApp providers ---------- */
export const getWhatsappSettings = () =>
  api.get(`/api/AdminIntegrations/whatsapp`);
export const saveWhatsappSettings = (data) =>
  api.post(`/api/AdminIntegrations/whatsapp`, data);

/* ---------- SMS providers ---------- */
export const getSmsSettings = () => api.get(`/api/AdminIntegrations/sms`);
export const saveSmsSettings = (data) =>
  api.post(`/api/AdminIntegrations/sms`, data);
